/**
 * Function that encodes an XML string. Converts all the XML characters
 * to their escaped values.
 * @param inputString
 */
export function encodeText(inputString: string): string {
  return inputString.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

/**
 * Function that decodes an encoded XML string. Basically, returns the string
 * to its original XML format.
 * @param inputString
 */
export function decodeText(inputString: string): string {
  return inputString.replace(/&apos;/g, '\'')
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&');
}